/* eslint-disable react/prop-types */
import React from 'react'

import { IconProps } from '.'

const GenderBoy: React.FC<IconProps> = ({ size = 16, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 16"
      {...rest}
    >
      <g fill="#595959" clipPath="url(#clip0_408_8625)">
        <path d="M15.325 1.199a.602.602 0 00-.038-.151v-.005h-.001a.618.618 0 00-.107-.168.623.623 0 00-.117-.105l-.004-.002a.6.6 0 00-.175-.078.609.609 0 00-.161-.024h-4.278a.611.611 0 000 1.223h2.802L9.6 5.535a5.469 5.469 0 00-3.433-1.203 5.506 5.506 0 00-5.5 5.5c0 3.033 2.468 5.5 5.5 5.5 3.033 0 5.5-2.467 5.5-5.5 0-1.262-.425-2.46-1.203-3.433l3.648-3.647v2.802a.611.611 0 001.222 0V1.277c0-.012-.003-.025-.004-.037a.617.617 0 00-.004-.041zM6.166 14.11A4.282 4.282 0 011.89 9.833a4.282 4.282 0 017.303-3.028 4.282 4.282 0 01-3.026 7.305z"></path>
        <path
          fillRule="evenodd"
          d="M15.287 1.048a.602.602 0 01.042.192l.002.016a.156.156 0 01.002.021v4.278a.611.611 0 01-1.222 0V2.753L10.463 6.4a5.469 5.469 0 011.203 3.433c0 3.033-2.467 5.5-5.5 5.5a5.506 5.506 0 01-5.5-5.5c0-3.033 2.468-5.5 5.5-5.5 1.263 0 2.46.425 3.433 1.203l3.647-3.647h-2.802a.611.611 0 010-1.223h4.278a.609.609 0 01.197.036.6.6 0 01.14.067h.003a.623.623 0 01.14.135h.001a.618.618 0 01.083.138v.003l.001.003zm.064-.02c.021.053.033.107.04.162m-.04-.162a.695.695 0 00-.096-.165l-.001-.002c-.008-.009-.016-.02-.026-.03A.69.69 0 0015.1.715m-.2-.089A.675.675 0 0014.722.6h-4.278a.678.678 0 000 1.355h2.641L9.594 5.447a5.535 5.535 0 00-3.428-1.18A5.573 5.573 0 00.6 9.832 5.573 5.573 0 006.166 15.4a5.573 5.573 0 005.567-5.567c0-1.257-.417-2.45-1.18-3.427l3.491-3.492v2.641a.678.678 0 001.356 0V1.277a.202.202 0 00-.003-.027v-.004l-.001-.01a.743.743 0 00-.005-.046M1.955 9.833a4.216 4.216 0 004.211 4.211 4.216 4.216 0 002.979-7.191 4.216 4.216 0 00-7.19 2.98zm7.237-3.028a4.282 4.282 0 00-7.304 3.028 4.282 4.282 0 004.278 4.278 4.282 4.282 0 003.026-7.306z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_408_8625">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default GenderBoy
